import React from 'react';
import cx from 'classnames';

import Star from 'components/star/star';
import { FavoriteItemDto, TeamByNameDto } from 'utils/api/dto';
import { FAV_AND_RECENT_TYPE_TEAM } from 'widgets/favorites/constant';

import ResultWrapper from '../../search-components/result-wrapper';
import styles from '../../search-components/result-list.module.css';
import { FavoriteToggleHandler, SelectItemHandler } from '../search-dropdown/types';

type RecentTeamSearchResultProps = {
    processing: boolean;
    teams: TeamByNameDto[];
    isFavorite?: boolean;
    favTeamList?: FavoriteItemDto[];
    handleAddRecentData: SelectItemHandler;
    handleFavoriteToggle: FavoriteToggleHandler;
};

/** The found teams of a page search panel */
const RecentTeamSearchResult = ({
    processing,
    teams,
    isFavorite = false,
    favTeamList,
    handleAddRecentData,
    handleFavoriteToggle
}: RecentTeamSearchResultProps) => (
    <ResultWrapper processing={processing} isNoData={!teams.length}>
        {teams.map(({ acronymEn, logoHref, nameEn, teamId }) => {
            const favoriteTeam = isFavorite ? favTeamList?.find(item => item.itemEntityId === teamId) : undefined;

            return (
                <div key={teamId} className={styles.row}>
                    <button
                        type="button"
                        className={cx(styles.link, styles.item)}
                        onClick={() => handleAddRecentData(teamId, FAV_AND_RECENT_TYPE_TEAM)}
                    >
                        <img className={styles.logo} alt={acronymEn ?? ''} src={logoHref ?? undefined} />
                        {nameEn || '-'}
                    </button>
                    {isFavorite ? (
                        <button
                            type="button"
                            className={styles.favoriteButton}
                            onClick={() =>
                                handleFavoriteToggle(favoriteTeam?.id, { id: teamId, type: FAV_AND_RECENT_TYPE_TEAM })
                            }
                        >
                            <Star active={!!favoriteTeam?.id} height={20} width={20} />
                        </button>
                    ) : null}
                </div>
            );
        })}
    </ResultWrapper>
);

export default RecentTeamSearchResult;
